"use strict";

(function(){
    var self = Fotobook.preview.bookletNavigation = {

        /** Слайдшоу активно */
        isSlideShow: false,
        slideshow_tm: undefined,
        slideshowDelay: 4,

        init: function () {
            $(document)
                .off(".editor-booklet")
                /**
                 * Слайдер элементы управления
                 */
                .on("click.editor-booklet", ".booklet-navigation .bv-button", self.bookletNavigation)
                /**
                 * Слайдер, ввод номера страницы пользователем
                 */
                .on("keyup.editor-booklet", ".booklet-navigation .bv-current", function (e) {
                    var self = $(this),
                        current = parseInt(self.val(), 10),
                        max = parseInt($('.bv-counter').attr('data-max'), 10);
                    if (isNaN(current) || 0 == current) {
                        self.val(1);
                    } else {
                        self.val(current > max ? max : current);
                    }
                    if (e.keyCode == 13) {
                        $('.bv-accept').trigger('click');
                    }
                })
                // чекбокс активации/деактивации слайдшоу
                .on("change.editor-booklet", "#bv-run-slideshow", function (e) {
                    self.isSlideShow = $(this).prop('checked');
                    var curPage = $('.bv-current');
                    // запрещаем вводить страницу пользователю во время работы слайдшоу - это предотвращает зависание слайдера,
                    // также при малом интервале слайдера ввод страниц неудобен из за их затирания слайдером
                    if (undefined === curPage.attr('disabled')) {
                        curPage.attr('disabled', true);
                        self.slideshow_tm = undefined;
                    } else {
                        curPage.attr('disabled', false);
                    }
                    self._runSlideShow();
                })
                .ready(function () {
                    $('.booklet-navigation').find('.slideshowdelay-slider').slider({
                        min: 1,
                        max: 10,
                        value: self.slideshowDelay,
                        step: 1,
                        create: function (event, ui) {
                            var handle = $(this).find('.ui-slider-handle');
                            handle.addClass('custom-slider');
                            self.setSliderName();
                        },
                        slide: function (event, ui) {
                            self.slideshowDelay = ui.value;
                            self.setSliderName(ui.value);
                        },
                        stop: function () {
                        }
                    });
                })
        },

        /**
         * Слайдер - элементы управления слайдером
         * @returns {boolean}
         */
        bookletNavigation: function () {
            var button = $(this),
                pageNum = parseInt($('.bv-current').val(), 10);
            switch (true) {
                case button.hasClass('bv-next'):
                    $(document).triggerHandler(Fotobook.events.PREVIEW_NEXT);
                    break;
                case button.hasClass('bv-prev'):
                    $(document).triggerHandler(Fotobook.events.PREVIEW_PREV);
                    break;
                case button.hasClass('bv-accept'):
                    $(document).triggerHandler(Fotobook.events.PREVIEW_SCROLL, pageNum);
                    break;
                case button.hasClass('bv-to-start'):
                    $(document).triggerHandler(Fotobook.events.PREVIEW_SCROLL, 1);
                    break;
                case button.hasClass('bv-to-end'):
                    var max = parseInt($('.bv-counter').attr('data-max'), 10);
                    $(document).triggerHandler(Fotobook.events.PREVIEW_SCROLL, max);
                    break;
                default:
                    break;
            }
        },

        /**
         * Запустить слайдшоу
         */
        _runSlideShow: function () {
            if (self.isSlideShow && self.slideshow_tm === undefined) {

                self.slideshow_tm = setTimeout(function () {
                    if (!self.isSlideShow) {
                        // timer is going on but user disabled slide show
                        return false;
                    }
                    $(document).triggerHandler(Fotobook.events.PREVIEW_NEXT);
                    self.slideshow_tm = undefined;
                    self._runSlideShow();
                }, self.slideshowDelay * 1000);
            }
        },

        setSliderName: function(value){
            var $bookletNavigation = $('.booklet-navigation'),
                sliderName = $bookletNavigation.find('.slideshow-delay-slider').find('.slider-name');
            value = value || $bookletNavigation.find('.slideshowdelay-slider').slider('value');
            sliderName.text(value + ' ' + t('photobook-js-slidedelay-seconds'));
        },
    };
    self.init();
})();